import type { IData } from '../model/IData'
import { expectDefined } from './expectDefined'

export function getParentless(data: IData) {
	const parentless = new Set(Object.keys(data.personsById))
	for (const couple of Object.values(data.couplesById)) {
		if (couple.childIds) {
			for (const childId of couple.childIds) {
				parentless.delete(childId)
			}
		}
	}
	return Array.from(
		parentless.values().map((it) => expectDefined(data.personsById[it])),
	)
}
